import { useActivityDetailUiState } from '../../Activity/activityDetailsUiState'

export const useSharedActivityStore = () => {
  const store = useActivityDetailUiState()
  const { setCategories, setDateSelection, setRangeForDay } = store

  return { setCategories, setDateSelection, setRangeForDay }
}
